import React from 'react';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { get } from '~/actions/containers';
import { format } from '~/utils/format';
import Tag from '~/components/Tag';
import Title from '~/components/Title';
import styleDialog from '~/style/dialog.scss';
import style from './style.scss';

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      stockPage: 1,
    };
  }

  componentDidMount() {
    return get(this.props.dispatch, this.context.apiClient, this.props.data.id)
      .then(() => this.setState({ loading: false }))
      .catch(() => this.setState({ loading: false }));
  }

  renderShipping(container) {
    if (!container.shipping) {
      return <div />;
    }

    return (
      <div>
        <span>Shipping: </span>
        <a href={container.shipping.uri} target="_blank" rel="noopener noreferrer">
          {container.shipping.id} ({container.shipping.reference})
        </a>
      </div>
    );
  }

  renderRow(id) {
    const { order: orderOrg, container, articles } = this.props;
    const order = orderOrg || {};
    const goalOrder =
      typeof (order.articleIds || {})[id] === 'number' ? (order.articleIds || {})[id] : '-';
    const goalContainer =
      typeof (container.articleIds || {})[id] === 'number' ? (container.articleIds || {})[id] : '-';
    const goal = container.articleIds ? goalContainer : goalOrder;
    const goalType = container.articleIds ? 'container' : 'order';
    const stock = Object.values(articles)
      .filter(i => i.articleId === id)
      .reduce((s, v) => s + v.count, 0);
    return (
      <div key={id} className={style.stockRow}>
        <div className={style.title}>
          <Tag id={id} type="article" />
        </div>
        <div className={style.goal}>
          {goalType === 'order' && (goal === '-' ? '-' : `0 - ${goal}`)}
          {goalType === 'container' && goal}
        </div>
        <div
          className={[
            style.count,
            stock === goal && style.green,
            (stock > goal || (stock > 0 && goal === '-')) && style.red
          ].join(' ')}
        >
          {stock}
        </div>
      </div>
    );
  }

  renderDialog() {
    const { container, articles, rawMaterialStock } = this.props;
    const goal = container.articleIds || {};
    const articleIds = [
      ...new Set([...Object.values(articles).map(i => i.articleId), ...Object.keys(goal)])
    ];
    const rms = Object.values(rawMaterialStock);
    return (
      <div>
        <Button
          style={{ float: 'right' }}
          label="Edit details"
          className={style.buttonEdit}
          onClick={() => this.context.dialogPush('containerEdit', { id: container.id })}
        />
        <Title style={{ marginBottom: '10px' }}>Information</Title>
        <div>Container #{container.sku}</div>
        <div>Partynuts ID: {typeof container.partynutsId === 'number' ? container.partynutsId : 'Not set'}</div>
        <div>Type: {container.type || 'Unknown'}</div>
        <div>
          Dimension:{' '}
          {container.dimensions
            ? `${container.dimensions.width} x ${container.dimensions.height} x ${
                container.dimensions.depth
              } mm`
            : 'Unknown'}
        </div>
        <div>Weight: {container.dimensions ? `${container.weight} g` : 'Unknown'}</div>
        <div>Location: <Tag type="location" id={container.locationId} /></div>
        <div>Order: <Tag type="order" id={container.orderId} /></div>
        <div>ETA: {format.date(container.eta)}</div>
        {this.renderShipping(container)}
        {articleIds.length !== 0 && (
          <div className={style.range}>
            <Button
              primary
              icon="chevron_left"
              onClick={() => this.setState({ stockPage: this.state.stockPage - 1 })}
              disabled={this.state.stockPage < 2}
            />
            &nbsp;{this.state.stockPage}/{Math.ceil(articleIds.length / 10)}&nbsp;
            <Button
              primary
              icon="chevron_right"
              onClick={() => this.setState({ stockPage: this.state.stockPage + 1 })}
              disabled={this.state.stockPage >= Math.ceil(articleIds.length / 10)}
            />
          </div>
        )}
        <Title style={{ margin: '20px 0 10px 0' }}>Articles in stock</Title>
        {articleIds
          .slice((this.state.stockPage - 1) * 10, this.state.stockPage * 10)
          .map(id => this.renderRow(id))}
        {articleIds.length === 0 && <div>No articles in stock</div>}

        <Title style={{ margin: '20px 0 10px 0' }}>Raw Materials in stock</Title>
        {rms.slice((this.state.stockPage - 1) * 10, this.state.stockPage * 10).map(item => (
          <div key={item.rawMaterialId} className={style.stockRow}>
            <div className={style.title}>
              <Tag id={item.rawMaterialId} type="rawMaterial" />
            </div>
            <div className={style.count}>{item.count}</div>
          </div>
        ))}
        {rms.length === 0 && <div>No raw materials in stock</div>}

        {container.removed && <div className={style.removed}>REMOVED</div>}
      </div>
    );
  }

  render() {
    return (
      <div
        className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')}
        onClick={() => this.context.dialogClose(this.props.dialogId)}
      >
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton
            className={styleDialog.closeButton}
            icon="close"
            onClick={() => this.context.dialogClose(this.props.dialogId)}
          />
          <div className={styleDialog.content}>
            {this.state.loading && 'Loading'}
            {!this.state.loading && !this.props.container && '404'}
            {!this.state.loading && this.props.container && this.renderDialog()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const container =
    state.getIn(['containers', 'items', props.data.id]) &&
    state.getIn(['containers', 'items', props.data.id]).toJS();
  const order = container.orderId
    ? state.getIn(['orderNew', 'items', container.orderId]) &&
      state.getIn(['orderNew', 'items', container.orderId]).toJS()
    : null;
  const articles = state
    .getIn(['stock', 'items'])
    .filter(i => i.getIn(['location', 'id']) === props.data.id)
    .toJS();
  const rawMaterialStock = state
    .getIn(['rawMaterialStock', 'items'])
    .filter(i => i.getIn(['location', 'id']) === props.data.id)
    .toJS();
  return { container, order, articles, rawMaterialStock };
};

export default connect(mapStateToProps)(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/Container/index.js